// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1qIpa","colBig":"styles_colBig__19yci","colSmall":"styles_colSmall__1YmxI","shopifyNameWrapper":"styles_shopifyNameWrapper__XDNYH"};